import React, { useContext } from 'react';
import { MainContext } from '../../context/MainContext';

import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import * as Constants from '../api/constants';

let deviceId = 0;

export default function ControlTestMode() {
  const state = useContext(MainContext).state;
  deviceId = state.selectedDevice;

  const sendCommand = (command, value = "") => {
    const requestOptions = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        DeviceId: deviceId,
        Command: command,
        Value: value,
      }),
      credentials: 'include',
    };

    fetch(Constants.baseURL + Constants.apiSendCommand, requestOptions)
      .then((response) => {
        if (response.ok) {
          toast.success('Command sent successfully. Refreshing...', {
            position: 'top-right',
            autoClose: 5000,
          });

          setTimeout(() => state.refreshDeviceRF(deviceId), 3000);
          setTimeout(() => state.getUserDeviceRf(deviceId), 7000);
        } else {
          toast.error('Send failed. Please try again', {
            position: 'top-right',
            autoClose: 4000,
          });
        }
      })
      .catch((error) => console.log('request failed', error));
  };

  return (
    <React.Fragment>
      <ToastContainer />

      {/* Title */}
      <Typography
        component="h2"
        variant="h6"
        sx={{ color: 'white', mb: 1, fontWeight: 600 }}
      >
        Reboot Spa
      </Typography>

      {/* Main Tile */}
      <Paper
        sx={{
          p: 3,
          borderRadius: 2,
          bgcolor: 'rgba(255,255,255,0.05)',
          border: '1px solid rgba(255,255,255,0.08)',
          textAlign: 'center',
        }}
      >
        <Typography
          sx={{
            color: 'rgba(255,255,255,0.7)',
            fontSize: 14,
            mb: 2,
          }}
        >
          Restart the spa controller
        </Typography>

        {/* Reboot button */}
        <Button
          variant="contained"
          onClick={() => sendCommand('Reboot')}
          sx={{
            backgroundColor: '#d32f2f',
            color: 'white',
            textTransform: 'none',
            fontWeight: 600,
            px: 4,
            py: 1.2,
            borderRadius: 20,
            '&:hover': {
              backgroundColor: '#b71c1c',
            },
          }}
        >
          Reboot
        </Button>
      </Paper>
    </React.Fragment>
  );
}
